const initialState = {
    data: [],
    page: 1,
    lastPageNumber: 99999999,

    alreadyMounted: false,
};

function consultationsReducer(state = initialState, action) {
    let nextState;
    switch (action.type) {
        case "SET_CONSULATION_DATA":
            nextState = {
                ...state,
                data: action.value,
            };
            return nextState || state;
        case "SET_CONSULATION_PAGE":
            nextState = {
                ...state,
                page: action.value,
            };
            return nextState || state;
        case "SET_CONSULATION_LAST_PAGE":
            nextState = {
                ...state,
                lastPageNumber: action.value,
            };
            return nextState || state;
        case "SET_CONSULATION_TOTAL":
            nextState = {
                ...state,
                total: action.value,
            };
            return nextState || state;
        case "SET_CONSULATION_ALREADY_MOUNTED":
            nextState = {
                ...state,
                alreadyMounted: action.value,
            };
            return nextState || state;
        default:
            return state;
    }
}

export default consultationsReducer;